<template>
  <div>
    <div>
      <back :title="titlename"></back>
      <van-tabs v-model="active">
        <van-tab title="待审核" name="a">
          <div class="list">
            <div class="listinfo">
              <div class="ywinfo">
                <p>姓名：</p>
                <p>业务类型：</p>
              </div>
              <button>查看详情</button>
              <div class="bz">
                <p>您好，您选择的业务已超时，不可取消！您的残疾证不是本人，无法办理。</p>
              </div>
            </div>
            <div class="line"></div>
          </div>
          <div class="list">
            <div class="listinfo">
              <div class="ywinfo">
                <p>姓名：</p>
                <p>业务类型：</p>
              </div>
              <button>查看详情</button>
              <div class="bz">
                <p>您好，您选择的业务已超时，不可取消！您的残疾证不是本人，无法办理。</p>
              </div>
            </div>
            <div class="line"></div>
          </div>
        </van-tab>
        <van-tab title="已办理" name="b">
          <div class="list">
            <div class="listinfo">
              <div class="ywinfo">
                <p>姓名：</p>
                <p>业务类型：</p>
              </div>
              <button>查看详情</button>
              <div class="bz">
                <p>您好，您选择的业务已超时，不可取消！您的残疾证不是本人，无法办理。</p>
              </div>
            </div>
            <div class="line"></div>
          </div>
        </van-tab>
      </van-tabs>
    </div>
  </div>
</template>

<script>
  export default {
      data() {
        return {
          titlename:"上门办业务审核",
          active:'a'
        };
      },
      created:function(){
        console.log(this.$store.state.openId)
      },
      methods:{
        //跳转
      }
    };
</script>

<style lang="less" scoped>
  .list{
    font-size: .3rem;
    .listinfo{
      padding: .4rem;
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      .ywinfo{
        font-size: .3rem;
        p{
          margin-bottom: .2rem;
        }
      }
      button{
        color: #3349f2;
        font-size: .3rem;
        border: .01rem solid #3349f2;
        background: white;
        border-radius: .05rem;
        width: 1.8rem;
        height: .58rem;
      }
      .bz{
        width: 100%;
        color: #f28033;
        border-top: .01rem solid #f6f6f6;
        padding-top: .2rem;
      }
    }
    .line{
      width: 100%;
      height: .2rem;
      background: #f6f6f6;
    }
  }
  /deep/.van-tab--active{
    color:#f28033
  }
  /deep/.van-tabs__line{
    background-color: #f28033;
    width: 1.6rem;
  }
  /deep/.van-tab{
    font-size: .3rem;
  }
</style>



// WEBPACK FOOTER //
// src/pages/verifylist.vue